<template>
	<div class="dictionary-data">
		<v-add-dict-data
			:dialogDict="dialogDict"
			:langList="langList"
			:dictForm="dictForm"
			v-on:cancel="cancel"
		></v-add-dict-data>
		<v-search-dict-data
			v-on:addDict="addDict"
			:dict="dict"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
		></v-search-dict-data>
		<div class="dict vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="dictList"
				style="width: 100%"
			>
				<el-table-column
					prop="label"
					:label="$t('dictData.label')"
				></el-table-column>
				<el-table-column
					prop="value"
					:show-overflow-tooltip="true"
					:label="$t('dictData.value')"
				></el-table-column>
				<el-table-column
					prop="sort"
					:label="$t('dictData.dictSort')"
				></el-table-column>

				<el-table-column
					prop="notes"
					:label="$t('dictData.notes')"
					width="200"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('dictData.createTime')"
					width="200"
				>
					<template slot-scope="scope">
						<span class="times">{{ scope.row.createTime }}</span>
					</template>
				</el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					width="200"
				>
					<template slot-scope="scope">
						<el-button size="mini" @click="editDict(scope.row)">{{
							$t("common.edit")
						}}</el-button>
						<el-button type="danger" size="mini" @click="delDict(scope.row)">{{
							$t("common.delete")
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="dict.pageIndex"
				:total="dict.totalSize"
				:page-size="dict.pageSize"
				@current-change="loadDict"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import vAddDictData from "@/components/system/dictData/AddDictData";
import vSearchDictData from "@/components/system/dictData/SearchDictData";

export default {
	name: "DictionaryData",
	components: {
		vAddDictData,
		vSearchDictData,
	},
	data() {
		return {
			dictList: [],
			dictForm: {
				codesId: "",
				id: "",
				type: "",
				codesLabels: [{ lang: "", label: "", key: Date.now() }],
				value: "",
				sort: 1,
				notes: "",
			},
			dict: {
				codesId: "",
				type: "",
				name: "",
				pageIndex: 1,
				pageSize: 10,
				totalSize: 0,
			},
			dialogDict: false,
			loading: false,
			langList: [],
		};
	},
	mounted() {
		this.dict.codesId = this.$route.params.codesId;
		this.dict.type = this.$route.params.dictType;
		this.loadDict();
		this.listLang();
	},
	methods: {
		loadDict(pageIndex) {
			this.loading = true;
			this.dict.pageIndex = pageIndex ? pageIndex : 1;
			this.$api
				.request(this.$url.DictData.page, this.$method.get, this.dict)
				.then(res => {
					if (res.code === 0) {
						this.dictList = res.data.records;
						this.dict.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		listLang() {
			this.$api.dict("sys_lang_list").then(res => {
				if (res.code === 0) {
					this.langList = res.data;
				}
			});
		},

		addDict() {
			this.dialogDict = true;
			this.dictForm.codesLabels = [
				{ lang: "zh_CN", label: "", key: Date.now() },
			];
			this.dictForm.codesId = this.dict.codesId;
			this.dictForm.type = this.dict.type;
			this.dictForm.sort = this.dict.totalSize + 1;
		},

		onSubmit(dict) {
			this.dict = dict;
			this.loadDict();
		},

		editDict(row) {
			this.dialogDict = true;
			Object.keys(this.dictForm).forEach(key => {
				this.dictForm[key] = row[key];
			});
			this.dictForm.codesLabels = [
				{ lang: "zh_CN", label: "", key: Date.now() },
			];
		},

		delDict(row) {
			this.$confirm(this.$t("dictData.isDel"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.DictData.delete, this.$method.delete, {
						ids: [row.id],
					})
					.then(res => {
						if (res.code === 0) {
							this.$message.success(this.$t("dictData.del"));
							this.loadDict();
						}
					});
			});
		},
		resetSearch(dict) {
			this.dict = dict;
			this.loadDict();
		},

		cancel(dialogDict, state) {
			this.dialogDict = dialogDict;
			if (state) {
				this.loadDict();
			}
		},
	},
};
</script>

<style scoped></style>
